import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Toast from "./Toast.vue";
import { useToast } from "@/composables/useToast";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToast();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Toast, {
    visible: _unref(toast).state.value.visible,
    message: _unref(toast).state.value.message,
    type: _unref(toast).state.value.type,
    onClose: _unref(toast).hide
  }, null, 8, ["visible", "message", "type", "onClose"]))
}
}

})